const config = {
  appURL: process.env.REACT_APP_APP_URL ?? "http://localhost:3000",
  apiURL: process.env.REACT_APP_API_URL ?? "http://localhost:8000",
  gDriveApi: process.env.REACT_APP_PWA_API_URL ??"http://localhost:5000",
  showDebug: false
}

export default config
